// Presentation-only translations for the native mobile loading overlay.
// The loading event payloads, progress calculations and offline pipeline stay unchanged.
// Only known UI messages are localized; Activity names and diagnostics are kept verbatim.
const translations = {
  'Preparing Placement...': ['Đang chuẩn bị bài đánh giá xếp lớp...', 'Preparando la evaluación de nivel...', 'Ap prepare evalyasyon plasman an...'],
  'Preparing content...': ['Đang chuẩn bị nội dung...', 'Preparando el contenido...', 'Ap prepare kontni an...'],
  'Preparing assessment...': ['Đang chuẩn bị bài đánh giá...', 'Preparando la evaluación...', 'Ap prepare evalyasyon an...'],
  'Preparing learning content...': ['Đang chuẩn bị nội dung học tập...', 'Preparando el contenido de aprendizaje...', 'Ap prepare kontni aprantisaj la...'],
  'Please keep the app open': ['Vui lòng giữ ứng dụng mở', 'Mantén la aplicación abierta', 'Tanpri kite aplikasyon an ouvè'],
  'Preparing fast offline package...': ['Đang chuẩn bị gói ngoại tuyến nhanh...', 'Preparando el paquete sin conexión rápido...', 'Ap prepare pake offline rapid la...'],
  'Preparing content': ['Đang chuẩn bị nội dung', 'Preparando el contenido', 'Ap prepare kontni an'],
  'Building offline package': ['Đang tạo gói ngoại tuyến', 'Creando el paquete sin conexión', 'Ap kreye pake offline la'],
  'Downloading package': ['Đang tải gói dữ liệu', 'Descargando el paquete', 'Ap telechaje pake a'],
  'Downloading content': ['Đang tải nội dung', 'Descargando contenido', 'Ap telechaje kontni'],
  'Downloading required files': ['Đang tải các tệp cần thiết', 'Descargando los archivos necesarios', 'Ap telechaje fichye ki nesesè yo'],
  'Checking content...': ['Đang kiểm tra nội dung...', 'Comprobando el contenido...', 'Ap verifye kontni an...'],
  'Checking learning activities...': ['Đang kiểm tra các hoạt động học tập...', 'Comprobando las actividades de aprendizaje...', 'Ap verifye aktivite aprantisaj yo...'],
  'Checking offline content': ['Đang kiểm tra nội dung ngoại tuyến', 'Comprobando el contenido sin conexión', 'Ap verifye kontni offline la'],
  'Checking offline content...': ['Đang kiểm tra nội dung ngoại tuyến...', 'Comprobando el contenido sin conexión...', 'Ap verifye kontni offline la...'],
  'Reading runtime configuration...': ['Đang đọc cấu hình ứng dụng...', 'Leyendo la configuración de la aplicación...', 'Ap li konfigirasyon aplikasyon an...'],
  'Building content list...': ['Đang tạo danh sách nội dung...', 'Creando la lista de contenido...', 'Ap kreye lis kontni an...'],
  'Preparing package request...': ['Đang chuẩn bị yêu cầu tải gói...', 'Preparando la solicitud del paquete...', 'Ap prepare demann pake a...'],
  'Preparing content download...': ['Đang chuẩn bị tải nội dung...', 'Preparando la descarga del contenido...', 'Ap prepare telechajman kontni an...'],
  'Preparing download list': ['Đang chuẩn bị danh sách tải xuống', 'Preparando la lista de descargas', 'Ap prepare lis telechajman an'],
  'Learning content': ['Nội dung học tập', 'Contenido de aprendizaje', 'Kontni aprantisaj'],
  'Existing content found': ['Đã tìm thấy nội dung có sẵn', 'Se encontró contenido existente', 'Nou jwenn kontni ki deja la'],
  'Fast package unavailable': ['Không có gói tải nhanh', 'Paquete rápido no disponible', 'Pake rapid la pa disponib'],
  'continuing with standard download...': ['đang tiếp tục tải xuống thông thường...', 'continuando con la descarga normal...', 'n ap kontinye ak telechajman nòmal la...'],
  'Checking downloaded content': ['Đang kiểm tra nội dung đã tải', 'Comprobando el contenido descargado', 'Ap verifye kontni ki telechaje a'],
  'Connection lost. Waiting to reconnect...': ['Mất kết nối. Đang chờ kết nối lại...', 'Se perdió la conexión. Esperando reconexión...', 'Koneksyon an pèdi. N ap tann li retounen...'],
  'Connection interrupted. Retrying download...': ['Kết nối bị gián đoạn. Đang thử tải lại...', 'Conexión interrumpida. Reintentando la descarga...', 'Koneksyon an koupe. N ap eseye telechaje ankò...'],
  'Connection restored. Resuming download...': ['Đã kết nối lại. Tiếp tục tải xuống...', 'Conexión restablecida. Reanudando la descarga...', 'Koneksyon an retounen. N ap kontinye telechaje...'],
  'Downloading learning content': ['Đang tải nội dung học tập', 'Descargando contenido de aprendizaje', 'Ap telechaje kontni aprantisaj'],
  'Validating offline content': ['Đang xác minh nội dung ngoại tuyến', 'Validando el contenido sin conexión', 'Ap valide kontni offline la'],
  'Saving offline package...': ['Đang lưu gói ngoại tuyến...', 'Guardando el paquete sin conexión...', 'Ap anrejistre pake offline la...'],
  'Content ready offline': ['Nội dung đã sẵn sàng để dùng ngoại tuyến', 'Contenido listo para usar sin conexión', 'Kontni an pare pou itilize offline'],
  'Placement preparation failed': ['Không thể chuẩn bị bài đánh giá xếp lớp', 'Error al preparar la evaluación de nivel', 'Preparasyon evalyasyon plasman an echwe'],
  'Custom Level preparation failed': ['Không thể chuẩn bị cấp độ tùy chỉnh', 'Error al preparar el nivel personalizado', 'Preparasyon nivo pèsonalize a echwe'],
  'Loading app data...': ['Đang tải dữ liệu ứng dụng...', 'Cargando los datos de la aplicación...', 'Ap chaje done aplikasyon an...'],
  'Loading mobile runtime from server...': ['Đang tải dữ liệu ứng dụng từ máy chủ...', 'Cargando los datos móviles del servidor...', 'Ap chaje done mobil yo sou sèvè a...'],
  'Preparing app...': ['Đang chuẩn bị ứng dụng...', 'Preparando la aplicación...', 'Ap prepare aplikasyon an...'],
  'Mobile assets loaded': ['Đã tải tài nguyên ứng dụng', 'Recursos de la aplicación cargados', 'Resous aplikasyon an chaje'],
  'Loading activity...': ['Đang tải hoạt động...', 'Cargando la actividad...', 'Ap chaje aktivite a...'],
  'Preparing activity content': ['Đang chuẩn bị nội dung hoạt động', 'Preparando el contenido de la actividad', 'Ap prepare kontni aktivite a'],
  'Loading learning session...': ['Đang tải phiên học...', 'Cargando la sesión de aprendizaje...', 'Ap chaje sesyon aprantisaj la...'],
  'Connecting to server': ['Đang kết nối máy chủ', 'Conectando con el servidor', 'Ap konekte ak sèvè a'],
  'Loading session data from server': ['Đang tải dữ liệu phiên học từ máy chủ', 'Cargando datos de la sesión desde el servidor', 'Ap chaje done sesyon an sou sèvè a'],
  'Placement package ready': ['Gói đánh giá xếp lớp đã sẵn sàng', 'Paquete de evaluación de nivel listo', 'Pake evalyasyon plasman an pare'],
  'Finalizing mobile session': ['Đang hoàn tất phiên học', 'Finalizando la sesión móvil', 'Ap finalize sesyon mobil la'],
  'Loading Custom Content menu from server...': ['Đang tải menu nội dung tùy chỉnh từ máy chủ...', 'Cargando el menú de contenido personalizado...', 'Ap chaje meni kontni pèsonalize a...'],
  'Loading Custom Content menu from server': ['Đang tải menu nội dung tùy chỉnh từ máy chủ', 'Cargando el menú de contenido personalizado', 'Ap chaje meni kontni pèsonalize a'],
  'Custom Content menu ready': ['Menu nội dung tùy chỉnh đã sẵn sàng', 'Menú de contenido personalizado listo', 'Meni kontni pèsonalize a pare'],
  'Checking saved Custom Level...': ['Đang kiểm tra cấp độ tùy chỉnh đã lưu...', 'Comprobando el nivel personalizado guardado...', 'Ap verifye nivo pèsonalize ki anrejistre a...'],
  'Custom Level ready offline': ['Cấp độ tùy chỉnh đã sẵn sàng ngoại tuyến', 'Nivel personalizado listo sin conexión', 'Nivo pèsonalize a pare offline'],
  'Updating Placement Menu': ['Đang cập nhật menu đánh giá xếp lớp', 'Actualizando el menú de evaluación de nivel', 'Ap mete meni evalyasyon plasman an ajou'],
  'Building Custom Content': ['Đang tạo nội dung tùy chỉnh', 'Creando contenido personalizado', 'Ap kreye kontni pèsonalize'],
  'Creating Custom Content on server': ['Đang tạo nội dung tùy chỉnh trên máy chủ', 'Creando contenido personalizado en el servidor', 'Ap kreye kontni pèsonalize sou sèvè a'],
  'Loading data...': ['Đang tải dữ liệu...', 'Cargando datos...', 'Ap chaje done...'],
  'Almost ready...': ['Sắp hoàn tất...', 'Casi listo...', 'Prèske pare...'],
  'Uploading data...': ['Đang tải dữ liệu lên...', 'Subiendo datos...', 'Ap voye done yo...'],
  'Preparing video...': ['Đang chuẩn bị video...', 'Preparando el video...', 'Ap prepare videyo a...'],
  'This video has not been downloaded. Connect to the internet to watch it.': [
    'Video này chưa được tải xuống. Hãy kết nối Internet để xem.',
    'Este video no se ha descargado. Conéctate a internet para verlo.',
    'Videyo sa a poko telechaje. Konekte sou entènèt pou gade li.',
  ],
  'Unable to load this video.': ['Không thể tải video này.', 'No se pudo cargar el video.', 'Nou pa ka chaje videyo sa a.'],
  'Loading...': ['Đang tải...', 'Cargando...', 'Ap chaje...'],
};

const languageIndex = { vm: 0, es: 1, hc: 2 };

const localized = (english, index) => translations[english]?.[index] || english;

// Keep dynamic amounts, file sizes, IDs, progress and Activity names untouched.
const localizeSuffix = (suffix, index) => {
  const requests = suffix.match(/^(\d+\s*\/\s*\d+) requests$/);
  if (requests) return `${requests[1]} ${['yêu cầu', 'solicitudes', 'demann'][index]}`;
  const seconds = suffix.match(/^(\d+)s$/);
  if (seconds) return `${seconds[1]}${[' giây', ' s', ' s'][index]}`;
  const activities = suffix.match(/^(\d+) activities$/);
  if (activities) return `${activities[1]} ${['hoạt động', 'actividades', 'aktivite'][index]}`;
  const retrying = suffix.match(/^retrying (\d+)$/);
  if (retrying) return `${['đang thử lại', 'reintentando', 'ap eseye ankò'][index]} ${retrying[1]}`;
  const downloading = suffix.match(/^downloading (.+) only$/);
  if (downloading) return `${['chỉ tải', 'descargando solo', 'ap telechaje sèlman'][index]} ${downloading[1]}`;
  return localized(suffix, index);
};

export const localizeMobileLoadingText = (value, localeCode) => {
  if (typeof value !== 'string' || !value) return value;
  const code = String(localeCode || '').trim().toLowerCase().split(/[-_]/)[0];
  const index = languageIndex[code];
  if (index === undefined) return value; // English and unsupported locales: unchanged.

  if (translations[value]) return localized(value, index);

  if (value.startsWith('Unpacking package ')) {
    const match = value.match(/^Unpacking package (\d+\s*\/\s*\d+)\.\.\.$/);
    if (match) return `${['Đang giải nén gói', 'Descomprimiendo el paquete', 'Ap dekonprese pake'][index]} ${match[1]}...`;
  }

  if (value.startsWith('Connection lost. Waiting to reconnect... ')) {
    const match = value.match(/^Connection lost\. Waiting to reconnect\.\.\. (\d+\s*\/\s*\d+) files ready$/);
    if (match) return `${localized('Connection lost. Waiting to reconnect...', index)} ${match[1]} ${['tệp đã sẵn sàng', 'archivos listos', 'fichye pare'][index]}`;
  }

  // Event details use a middle dot to separate translated status from raw byte counts.
  if (value.includes(' · ')) {
    const parts = value.split(' · ');
    const translatedFirst = localized(parts[0], index);
    if (translatedFirst !== parts[0]) {
      return [translatedFirst, ...parts.slice(1).map((part) => localizeSuffix(part, index))].join(' · ');
    }
  }

  // The Activity name is authored content, not loading UI text.
  if (value.startsWith('Preparing ') && !value.endsWith('...')) {
    return `${['Đang chuẩn bị', 'Preparando', 'Ap prepare'][index]} ${value.slice('Preparing '.length)}`;
  }

  return value;
};

// Resolve the native loading UI from the current learning session, never from
// the Login screen when a Solution or Placement language is available.
// Pre-SET_SOLUTION Placement can have English Redux defaults while the active
// prebuilt and subsequent Play UI are in Vietnamese/Spanish/Haitian Creole.
export const resolveMobileLoadingLocale = (state = {}) => {
  const play = state.flinkPlay || {};
  const onboarding = play.learner?.customContentOnboarding || {};
  const assessment = play.mobileBootstrap?.offlineAssessment || {};
  const generated = play.mobileBootstrap?.generatedCustomContentLevel || {};
  const explicitInterface = String(
    onboarding.explanationLanguage
    || assessment.explanationLanguage
    || generated.contentPlan?.explanationLanguage
    || '',
  ).trim().toLowerCase();
  const solution = String(play.solutionLocale?.code || '').trim().toLowerCase();
  const instruction = String(
    onboarding.instructionLanguage
    || assessment.instructionLanguage
    || generated.instructionLanguage
    || generated.contentPlan?.instructionLanguage
    || play.activityLocale?.code
    || '',
  ).trim().toLowerCase();
  const login = String(state.status?.lang?.code || '').trim().toLowerCase();
  const normalize = (code) => code.split(/[-_]/)[0];

  if (explicitInterface) return { code: normalize(explicitInterface), source: 'session.explanationLanguage' };
  // Transition keeps its explicit interface language distinct from the Activity language.
  if (play.solution?.languageMode === 'transition' && solution) {
    return { code: normalize(solution), source: 'solution.transition' };
  }
  if (solution && normalize(solution) !== 'en') {
    return { code: normalize(solution), source: 'flinkPlay.solutionLocale' };
  }
  if (instruction && normalize(instruction) !== 'en') {
    return { code: normalize(instruction), source: 'session.instructionLanguage' };
  }
  if (solution) return { code: normalize(solution), source: 'flinkPlay.solutionLocale' };
  if (instruction) return { code: normalize(instruction), source: 'session.instructionLanguage' };
  return { code: normalize(login || 'en'), source: login ? 'status.lang (before session)' : 'default' };
};

// These three IDs are authored in the Strings catalog. All other mobile-only
// operational messages retain the existing display-side dictionary.
export const MOBILE_LOADING_STRING_IDS = Object.freeze({
  'Preparing assessment...': 3866,
  'Preparing learning content...': 3867,
  'Please keep the app open': 3868,
});
